import { render, staticRenderFns } from "./TheaterEmailCreateContainer.vue?vue&type=template&id=2125178c&scoped=true"
import script from "./TheaterEmailCreateContainer.vue?vue&type=script&lang=js"
export * from "./TheaterEmailCreateContainer.vue?vue&type=script&lang=js"
import style0 from "./TheaterEmailCreateContainer.vue?vue&type=style&index=0&id=2125178c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2125178c",
  null
  
)

export default component.exports